module.exports = __webpack_public_path__ + "img/2.ed5d4c62.png";